<template>
    <div class="projects-items-section">
        <div class="project-item-mobile" v-for="(item, index) in projectItemsArr">
            <router-link :to="{ name : 'project-card' , params:{id : item.slug }}" class="link-to-page">
                <div class="item-img">
                    <div class="img-in" :style="'background-image: url(' + item.acf.project_img + ');'"></div>
                    <div class="btn-go">
                        <svgIcon name="arrow-go-right"/>
                    </div>
                </div>
                <div class="item-desc">
                    <p>{{ item.acf.project_name }}</p>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'project-item-mobile',
        props: ['projectItemsArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
                initVideo: false,
                dataArr: null,
            }
        },
        computed: mapGetters({
            // projectsItems: 'loadIndexPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            // this.getProjectItems();
            // this.$store.watch(
            //     (state) => state.indexPage,
            //     (newValue) => {
            //         if (newValue) 
            //         this.getProjectItems();
            //     }
            // );
            // this.$store.watch(
            //     (state) => state.projectItemsDefault,
            //     (newValue) => {
            //         if (newValue) 
            //         this.getProjectItems();
            //     }
            // );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/projects/project-item-mobile.scss';
    // @import '@/styles/respond/index-promo/respond-promo-fine-finish.scss';
</style>